if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.getElementById('cart');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-hidden") {
          const isHidden = target.getAttribute("aria-hidden") === "true";

          if (!isHidden) {
            console.log("open mini cart");
            reloadBssScript(); 
            BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  }, 5000);
}

function reloadBssScript() { 
    // Tìm thẻ script cũ
    const oldScript = document.querySelector('script[src$="bss-b2b-v3.js"]');
    if (oldScript) oldScript.remove(); 
    // xóa nó khỏi DOM

    // Tạo thẻ script mới 
    const newScript = document.createElement('script'); 
    newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-v3.js';

    // Khi tải xong thì log lại (không bắt buộc) 
    newScript.onload = () => console.log('Đã reload bss-b2b-v3.js');

    // Gắn vào body (hoặc head đều được)
    document.body.appendChild(newScript); 
}

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1500);
    }
  });
});
